import React from "react";
import { Api } from "../utils/api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/pt";

import AlertDialog from "../components/alert.component";
import Button from "@material-ui/core/Button";

class CallsBookedList extends React.Component {
  constructor() {
    super();
    this.api = new Api();
    this.getBookedCalls = this.getBookedCalls.bind(this);
    this.taskDone = this.taskDone.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  state = {
    bookedCalls: null,
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
  };

  componentDidMount() {
    this.getBookedCalls();
    this.showAlert();
    this.closeAlert();
    const user_id = localStorage.getItem("id");
    this.getBookedCalls(user_id);
  }

  getBookedCalls = (user_id) => {
    if (user_id) {
      this.api
        .get(`/bookcalls`, { social_worker_id: user_id })
        .then(({ data = null }) => {
          data.map((e) => {
            if (e.status === false)
              e.title =
                e.title +
                "\t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t \t CONCLUÍDO";
          });
          this.setState({ bookedCalls: data });
        });
    }
  };

  showAlert() {
    const request_id = sessionStorage.request_id;
    const url = "https://ops.laresonline.pt/user_requests/" + request_id;

    this.setState({ showAlert: true });
    this.setState({
      alertTitle: (
        <center>
          {" "}
          <a href={url}>Ir para o pedido</a>{" "}
        </center>
      ),
    });
    this.setState({
      alertMessage: <Button onClick={this.taskDone}>Tarefa Concluída</Button>,
    });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  taskDone() {
    const event_id = sessionStorage.event_id;
    if (event_id) {
      this.api
        .patch(`/bookcalls/${event_id}`, { status: 0 })
        .then((res) => {
          console.log("patch " + event_id + ": ", res);
        })
        .catch((err) => {
          console.log("patch " + event_id + ": ", err);
        })
        .then((res) => {
          //Atualizar o estado dos agendamentos
          const user_id = localStorage.getItem("id");
          this.getBookedCalls(user_id);
        });
    }
  }

  render() {
    const localizer = momentLocalizer(moment);

    const messages = {
      allDay: "Dia todo",
      previous: "Anterior",
      next: "Seguinte",
      today: "Hoje",
      month: "Mês",
      week: "Semana",
      day: "Dia",
      agenda: "Agenda",
      date: "Data",
      time: "Hora",
      event: "Evento",
    };

    const bookedCalls = this.state.bookedCalls;

    return (
      <div className="App" class="container">
        {bookedCalls && (
          <Calendar
            messages={messages}
            localizer={localizer}
            events={bookedCalls}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 600 }}
            defaultView="day"
            min={new Date(2020, 1, 0, 0, 0, 0)}
            max={new Date(3000, 1, 0, 0, 0, 0)}
            onDoubleClickEvent={this.showAlert}
            onSelectEvent={({ request, id }) => {
              const request_id = request;
              const event_id = id;
              sessionStorage.setItem("request_id", request_id);
              sessionStorage.setItem("event_id", event_id);
            }}
          />
        )}
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </div>
    );
  }
}

export default CallsBookedList;
